import type { ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { TellescopeQueryProvider } from "@tellescope/tanstack-query";
import { enduserQueryClient } from "./enduserQueryClient";
import { useEnduserStore } from "../store/hooks";

interface EnduserQueryProviderProps {
  children: ReactNode;
}

export function EnduserQueryProvider({ children }: EnduserQueryProviderProps) {
  const session = useEnduserStore((state) => state.session);

  return (
    <QueryClientProvider client={enduserQueryClient}>
      <TellescopeQueryProvider session={session}>{children}</TellescopeQueryProvider>
    </QueryClientProvider>
  );
}
